import _ from 'underscore';
import xtend from 'xtend';
import mxtend from 'xtend/mutable';
import struct from 'observ-struct';
import observ from 'observ';
import reactUpdate from 'react-addons-update';

function Store () {
    var state = struct({
        isResolving: observ(false),
        data: struct({}),
        lastError: observ(false)
    });
    return state;
}

function WebsocketActions (state, id, opts) {
    if ( !(this instanceof WebsocketActions) ) {
        return new WebsocketActions(state, id, opts);
    }
    mxtend(this, opts);
    this.state = state;
    this.id = id;
}

WebsocketActions.prototype.update = function (event) {
    // console.log('WebsocketActions.prototype.update: %o', event);
    var newData = {};
    newData[event.data[this.id]] = {$set: event.data};
    this.state.data.set(reactUpdate(this.state.data(), newData));
};

WebsocketActions.prototype.edit = WebsocketActions.prototype.update;
WebsocketActions.prototype.add = WebsocketActions.prototype.update;
WebsocketActions.prototype.delete = function (event) {
    var data = this.state.data();
    delete data[event.data[this.id]];
    this.state.data.set(data);
};



// (Store state, string id)
function ApiActions (state, id, opts) {
    if ( !(this instanceof ApiActions) ) {
        return new ApiActions(state, id, opts);
    }
    mxtend(this, opts);
    this.state = state;
    this.id = id;
}

ApiActions.prototype.update = function (event) {
    // console.log('ApiActions.prototype.update: %o', event, this.state());
    var newData = {};
    newData[event.data[this.id]] = event.data;
    this.state.set(xtend(this.state(), {
        isResolving: false,
        data: xtend(this.state.data(), newData)
    }));
};

ApiActions.prototype.edit = ApiActions.prototype.update;
ApiActions.prototype.add = ApiActions.prototype.update;

ApiActions.prototype.get = function (event) {
    this.state.set(xtend(this.state(), {
        isResolving: false,
        data: _(event.data).indexBy(this.id)
    }));
};

ApiActions.prototype.asyncStart = function () {
    this.state.isResolving.set(true);
};

ApiActions.prototype.delete = function (event) {
    var data = this.state.data();
    delete data[event.data[this.id]];
    this.state.set(xtend(this.state(), {
        isResolving: false,
        data: data
    }));
};

ApiActions.prototype.error = function (event) {
    console.warn('Api Error', arguments, event);
    this.state.set(xtend(this.state(), {
        isResolving: false,
        lastError: event.message
    }));
};


Store.ApiActions = ApiActions;
Store.WebsocketActions = WebsocketActions;

// @XXX Store.ApiEvents.concat at Domain Store level
// need to replace Store.SubscribeToApi = Store.Subscribe.bind(null, Store.ApiEvents);
Store.ApiEvents = [
    'asyncStart',
    'edit',
    'editLink',
    'update',
    'add',
    'delete',
    'get',
    'error',
    'start',
    'stop',
    'publish',
    'unpublish',
    'getMostWatched',
    'getUpcomingEvents',
    'miscAssetToEvent',
    'getMiscAssets',
    'setPreferenceAsDefault',
    'getXMLConfigURI',

    'getByID',

    'getTranscriptInfo',
    'getText'
];
Store.WebsocketEvents = ['edit', 'add', 'delete'];

Store.Subscribe = function (eventNames, actions, emitter) {
    var evHandlers = eventNames.reduce(function (acc, evName) {
        acc[evName] = function (event) {
            actions[evName].call(actions, event);
        };
        return acc;
    }, {});

    eventNames.forEach(function (event) {
        // https://nodejs.org/api/events.html#events_emitter_emit_eventname_arg1_arg2
        emitter.on(event, evHandlers[event]);
    });

    return function unsubscribe () {
        _(evHandlers).forEach(function (fn, name) {
            emitter.removeListener(name, fn);
        });
    };
};

Store.SubscribeToApi = Store.Subscribe.bind(null, Store.ApiEvents);
Store.SubscribeToWebsocket = Store.Subscribe;

Store.Parse = function (state, parser) {
    var parsed = struct(state());
    state(function onChange (data) {
        // console.log('data: %o', data);
        parsed.set(parser(data));
    });
    return parsed;
};

export default Store;
